module.exports = __webpack_public_path__ + "img/bg8.8909fe40.png";